import { render, staticRenderFns } from "./BlogWidgetHorizontal.vue?vue&type=template&id=2abed3c1&scoped=true"
import script from "./BlogWidgetHorizontal.vue?vue&type=script&lang=js"
export * from "./BlogWidgetHorizontal.vue?vue&type=script&lang=js"
import style0 from "./BlogWidgetHorizontal.vue?vue&type=style&index=0&id=2abed3c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abed3c1",
  null
  
)

export default component.exports